module.exports = {
  apiHost: "https://api.chambersreserve.sensoreal.com.au",
  assetsHost: "https://assets.chambersreserve.sensoreal.com.au",
  contact: {
    address: "",
    email: "",
    phone: "1800 528 630",
    website:
      "https://avid.com.au/communities/residential/villaworld/qld/chambers-reserve",
  },
  formTemplate: "default",
  header: {
    logo: "",
    text: {
      en: "Your Chambers Reserve Selections",
    },
    color: "#fff",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_VWH_Reverse.png",
  links: {
    instagram: "https://www.instagram.com/villaworldhomes/",
    facebook:
      "https://web.facebook.com/AVIDPropertyGroupAustralia/?_rdc=1&_rdr",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    privacy: "",
    twitter: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
  },
  style: {
    primaryColor: "#535c52",
    textColor: "#fff",
  },
};
